import { createContext } from 'react';

export const CountryCodeContext = createContext(null);
